import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { AddNameTuneRequest } from '../api/nametune/addnametunerequest';
import { AddNameTuneResponse, AddNameTuneResponseDtoImpl } from '../api/nametune/addnametuneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class AddNameTuneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<AddNameTuneRequest, AddNameTuneResponse>
{
    private LOGGER: Logger = LogManager.getLogger(AddNameTuneAPIProcessorImpl.name);
    execute(request: AddNameTuneRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.LOGGER.log("onSuccess() invoked");

        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new AddNameTuneResponseDtoImpl(APIFeatures.ADD_NAMETUNE, "");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new AddNameTuneResponseDtoImpl(APIFeatures.ADD_NAMETUNE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

      this.getAPIFailure(new AddNameTuneResponseDtoImpl(APIFeatures.ADD_NAMETUNE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/addnametuneapiprocessor.tsx